<form [formGroup]="vivenuForm">
<div class="flex flex-col">
  <div>
    <h2 class="text-5xl m-10">
      <strong>vivenu</strong> {{ 'dashboard' | translate }}
    </h2>
  </div>
  <div class="bg-white p-10 grow">
    <div class="grid grid-cols-1 gap-6">
      <div>
        {{ 'current_volume' | translate }}: <b>{{ vivenuForm.controls.currentVolume.value }}</b>
      </div>
      <div class="text-right text-sm">
        <span>{{ usedBalance }}/{{ vivenuForm.controls.currentVolume.value }}</span>
        <mat-progress-bar mode="determinate" [value]="usedBalance / 10"></mat-progress-bar>
      </div>
      @if (loadedBalance && vivenuForm && vivenuForm.controls.currentVolume.value) {
      <div>
        {{ 'remaining_syncs' | translate: {remaining_syncs: vivenuForm.controls.currentVolume.value - usedBalance} }}
      </div>
      }
      <div>
        <button mat-raised-button color="primary">{{ 'upgrade_now' | translate }}</button>
      </div>
    </div>
  </div>
  <div>
    <h2 class="text-5xl m-10">
      <strong>vivenu</strong> {{ 'settings' | translate }}
    </h2>
  </div>
  <div class="bg-white p-10 grow">

      <div class="grid grid-cols-1 [&>*:nth-child(odd)]:bg-gray-50 [&>*:nth-child(odd)]:p-4 [&>*:nth-child(even)]:p-4">
        <div class="grid grid-cols-2 gap-x-4">
          <div>
            <mat-slide-toggle
              (change)="openActivationDialog($event)"
              labelPosition="after"
              formControlName="active">{{ 'integration_active' | translate }}</mat-slide-toggle>
          </div>
          <div>
            {{ 'integration_active_description' | translate }}
          </div>
        </div>
        <div class="grid grid-cols-2 gap-x-4">
          <div>
            <mat-form-field class="w-full">
              <mat-label>{{ 'api_key' | translate }}</mat-label>
              <input matInput formControlName="vivenuApiKey">
            </mat-form-field>
          </div>
          @if (vivenuForm.controls.vivenuApiKey.value && vivenuForm.controls.vivenuSellerId.value) {
            <div>
              <mat-form-field class="w-full">
                <mat-label>{{ 'vivenu_seller_id' | translate }}</mat-label>
                <input matInput formControlName="vivenuSellerId" [disabled]="true" [readonly]="true">
              </mat-form-field>
            </div>
          } @else {
            <div>
              {{ 'api_key_instructions' | translate }}
            </div>
          }
        </div>
        @if (vivenuForm.controls.vivenuApiKey.value && vivenuForm.controls.vivenuSellerId.value) {
          <div class="grid grid-cols-2 gap-x-4">
            <div>
              <mat-slide-toggle
                labelPosition="after"
                formControlName="useOrderObject">{{ 'use_order_object' | translate }}</mat-slide-toggle>
            </div>
            <div>
              {{ 'use_order_object_description' | translate }}
            </div>
          </div>
          @if (vivenuForm.controls.useOrderObject.value) {
            <div class="grid grid-cols-2 gap-x-4">
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'order_pipeline' | translate }}</mat-label>
                  <input matInput formControlName="orderPipeline">
                </mat-form-field>
              </div>
              <div>
                {{ 'order_pipeline_description' | translate }}
              </div>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'order_stage_aborted' | translate }}</mat-label>
                  <input matInput formControlName="orderStageAborted">
                </mat-form-field>
              </div>
              <div>
                {{ 'order_stage_aborted_description' | translate }}
              </div>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <mat-form-field class="w-full">
                <mat-label>{{ 'order_stage_pending' | translate }}</mat-label>
                <input matInput formControlName="orderStagePending">
              </mat-form-field>
              <div>
                {{ 'order_stage_pending_description' | translate }}
              </div>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <mat-form-field class="w-full">
                <mat-label>{{ 'order_stage_complete' | translate }}</mat-label>
                <input matInput formControlName="orderStageComplete">
              </mat-form-field>
              <div>
                {{ 'order_stage_complete_description' | translate }}
              </div>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <mat-form-field class="w-full">
                <mat-label>{{ 'order_stage_processed' | translate }}</mat-label>
                <input matInput formControlName="orderStageProcessed">
              </mat-form-field>
              <div>
                {{ 'order_stage_processed_description' | translate }}
              </div>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <mat-form-field class="w-full">
                <mat-label>{{ 'order_stage_canceled' | translate }}</mat-label>
                <input matInput formControlName="orderStageCanceled">
              </mat-form-field>
              <div>
                {{ 'order_stage_canceled_description' | translate }}
              </div>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <div>
                <button mat-raised-button type="button" (click)="saveOrderStages()">
                  {{ 'save_order_stages' | translate }}
                </button>
              </div>
            </div>
          } @else {
            <div class="grid grid-cols-2 gap-x-4">
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'deal_pipeline' | translate }}</mat-label>
                  <input matInput formControlName="dealPipeline">
                </mat-form-field>
              </div>
              <div>
                {{ 'deal_pipeline_description' | translate }}
              </div>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'deal_stage_aborted' | translate }}</mat-label>
                  <input matInput formControlName="dealStageAborted">
                </mat-form-field>
              </div>
              <div>
                {{ 'deal_stage_aborted_description' | translate }}
              </div>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <mat-form-field class="w-full">
                <mat-label>{{ 'deal_stage_pending' | translate }}</mat-label>
                <input matInput formControlName="dealStagePending">
              </mat-form-field>
              <div>
                {{ 'deal_stage_pending_description' | translate }}
              </div>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <mat-form-field class="w-full">
                <mat-label>{{ 'deal_stage_complete' | translate }}</mat-label>
                <input matInput formControlName="dealStageComplete">
              </mat-form-field>
              <div>
                {{ 'deal_stage_complete_description' | translate }}
              </div>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <mat-form-field class="w-full">
                <mat-label>{{ 'deal_stage_processed' | translate }}</mat-label>
                <input matInput formControlName="dealStageProcessed">
              </mat-form-field>
              <div>
                {{ 'deal_stage_processed_description' | translate }}
              </div>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <mat-form-field class="w-full">
                <mat-label>{{ 'deal_stage_canceled' | translate }}</mat-label>
                <input matInput formControlName="dealStageCanceled">
              </mat-form-field>
              <div>
                {{ 'deal_stage_canceled_description' | translate }}
              </div>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <div>
                <button mat-raised-button type="button" (click)="saveDealStages()">
                  {{ 'save_deal_stages' | translate }}
                </button>
              </div>
            </div>
          }
          <div class="grid grid-cols-2 gap-x-4">
            <div>
              <mat-slide-toggle
                labelPosition="after"
                (change)="openActivateSyncDialog($event, 'vivenuCreateContact')"
                formControlName="vivenuCreateContactActive">{{ 'sync_new_contacts' | translate }}</mat-slide-toggle>
            </div>
            @if (vivenuForm.controls.vivenuCreateContactActive.value) {
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'new_contacts_hmac_key' | translate }}</mat-label>
                  <input matInput formControlName="vivenuCreateContactHmacKey" [disabled]="true" [readonly]="true">
                </mat-form-field>
              </div>
            } @else {
              <div>
                {{ 'sync_new_contacts_description' | translate }}
              </div>
            }
          </div>
          <div class="grid grid-cols-2 gap-x-4">
            <div>
              <mat-slide-toggle
                labelPosition="after"
                (change)="openActivateSyncDialog($event, 'vivenuUpdateContact')"
                formControlName="vivenuUpdateContactActive">{{ 'sync_updated_contacts' | translate }}</mat-slide-toggle>
            </div>
            @if (vivenuForm.controls.vivenuUpdateContactActive.value) {
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'updated_contacts_hmac_key' | translate }}</mat-label>
                  <input matInput formControlName="vivenuUpdateContactHmacKey" [disabled]="true" [readonly]="true">
                </mat-form-field>
              </div>
            } @else {
              <div>
                {{ 'sync_updated_contacts_description' | translate }}
              </div>
            }
          </div>
          <div class="grid grid-cols-2 gap-x-4">
            <div>
              <mat-slide-toggle
                labelPosition="after"
                (change)="openActivateSyncDialog($event, 'vivenuTransactionComplete')"
                [disabled]="true"
                formControlName="vivenuTransactionCompleteActive">{{ 'sync_completed_purchases' | translate }}</mat-slide-toggle>
            </div>
            @if (vivenuForm.controls.vivenuTransactionCompleteActive.value) {
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'completed_purchases_hmac_key' | translate }}</mat-label>
                  <input matInput formControlName="vivenuTransactionCompleteHmacKey" [disabled]="true" [readonly]="true">
                </mat-form-field>
              </div>
            } @else {
              <div>
                {{ 'sync_completed_purchases_description' | translate }}
              </div>
            }
          </div>
          <div class="grid grid-cols-2 gap-x-4">
            <div>
              <mat-slide-toggle
                labelPosition="after"
                (change)="openActivateSyncDialog($event, 'vivenuCheckoutAborted')"
                [disabled]="true"
                formControlName="vivenuCheckoutAbortedActive">{{ 'sync_aborted_purchases' | translate }}</mat-slide-toggle>
            </div>
            @if (vivenuForm.controls.vivenuCheckoutAbortedActive.value) {
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'aborted_purchases_hmac_key' | translate }}</mat-label>
                  <input matInput formControlName="vivenuCheckoutAbortedHmacKey" [disabled]="true" [readonly]="true">
                </mat-form-field>
              </div>
            } @else {
              <div>
                {{ 'sync_aborted_purchases_description' | translate }}
              </div>
            }
          </div>
          <div class="grid grid-cols-2 gap-x-4">
            <div>
              <mat-slide-toggle
                labelPosition="after"
                (change)="openActivateSyncDialog($event, 'vivenuScan')"
                [disabled]="true"
                formControlName="vivenuScanActive">{{ 'sync_scans' | translate }}</mat-slide-toggle>
            </div>
            @if (vivenuForm.controls.vivenuScanActive.value) {
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'scan_hmac_key' | translate }}</mat-label>
                  <input matInput formControlName="vivenuScanHmacKey" [disabled]="true" [readonly]="true">
                </mat-form-field>
              </div>
            } @else {
              <div>
                {{ 'sync_scans_description' | translate }}
              </div>
            }
          </div>
          <div class="grid grid-cols-2 gap-x-4">
            <div>
            <mat-slide-toggle
              labelPosition="after"
              [disabled]="true"
              formControlName="displayLatestOrders">{{ 'display_latest_orders' | translate }}</mat-slide-toggle>
            </div>
            <div>
              {{ 'display_latest_orders_description' | translate }}
            </div>
          </div>
          <div class="grid grid-cols-2 gap-x-4">
            <div>
            <mat-slide-toggle
              (change)="openActivateSyncDialog($event, 'vivenuTicketsAsObjects')"
              labelPosition="after"
              [disabled]="true"
              formControlName="vivenuTicketsAsObjects">{{ 'tickets_as_custom_objects' | translate }}</mat-slide-toggle>
            </div>
            @if (vivenuForm.controls.vivenuScanActive.value) {
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'ticket_custom_object_id' | translate }}</mat-label>
                  <input matInput formControlName="vivenuTicketsCustomObjectId" [disabled]="true" [readonly]="true">
                </mat-form-field>
              </div>
            } @else {
              <div>
                {{ 'tickets_as_custom_objects_description' | translate }}
              </div>
            }
          </div>
          <div class="grid grid-cols-2 gap-x-4">
            <div>
            <mat-slide-toggle
              labelPosition="after"
              [disabled]="true"
              formControlName="displayTicketSeatsInContact">{{ 'display_ticket_seats' | translate }}</mat-slide-toggle>
            </div>
            <div>
              {{ 'display_ticket_seats_description' | translate }}
            </div>
          </div>
          <div class="grid grid-cols-2 gap-x-4">
            <div>
              <mat-slide-toggle
                (change)="openActivateSyncDialog($event, 'anonymizeData')"
                labelPosition="after"
                [disabled]="true"
                formControlName="anonymizeData">{{ 'anonymize_data' | translate }}</mat-slide-toggle>
            </div>
            <div>
              {{ 'anonymize_data_description' | translate }}
            </div>
          </div>
        }
      </div>
      @if (vivenuForm.controls.vivenuApiKey.value && !vivenuForm.controls.vivenuSellerId.value) {
        @if (apiKeyError) {
          <div class="text-red-500 mt-4">
            {{ apiKeyError }}
          </div>
        }
        <div class="mt-14">
          <button mat-raised-button type="button" (click)="useApiKey()">{{ 'use_api_key' | translate }}</button>
        </div>
      }

  </div>
  @if (vivenuForm.controls.vivenuApiKey.value && vivenuForm.controls.vivenuSellerId.value) {
  <div>
    <h2 class="text-5xl m-10">
      <strong>vivenu</strong> {{ 'field_mapping' | translate }}
    </h2>
  </div>
  <div class="bg-white p-10 grow mb-16">
    @if (hubspotProperties && vivenuFields) {
      <h2 class="font-bold text-lg mb-4">{{ 'contact_fields_to_hubspot' | translate }}</h2>
      <div class="grid grid-cols-1 gap-6 [&>*:nth-child(odd)]:bg-gray-50 [&>*:nth-child(odd)]:p-4 [&>*:nth-child(even)]:p-4">
        @for (field of vivenuFields; track field.id) {
          @if (!field.toExternal && field.objectType == 'contact') {
            <div class="grid grid-cols-3 gap-x-4">
              <div>
                <mat-slide-toggle
                  [disabled]="field.required"
                  [(ngModel)]="field.activeCreate" [ngModelOptions]="{standalone: true}">
                  {{ 'create_on_creation' | translate }}
                </mat-slide-toggle>
                <mat-slide-toggle
                  [disabled]="field.required"
                  [(ngModel)]="field.activeUpdate" [ngModelOptions]="{standalone: true}">
                  {{ 'overwrite_on_update' | translate }}
                </mat-slide-toggle>
              </div>
              <div>
                {{field.label | translate}} ({{field.fieldType}})
              </div>
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'hubspot_target_field' | translate }}</mat-label>
                  <input type="text"
                         placeholder="{{ 'hubspot_target_field' | translate }}"
                         matInput
                         [disabled]="!field.editable"
                         [(ngModel)]="field.value"
                         [ngModelOptions]="{standalone: true}"
                         (keyup)="filterEntries($event, 'contact', field.fieldType)"
                         [matAutocomplete]="auto">
                  <mat-autocomplete autoActiveFirstOption requireSelection #auto="matAutocomplete">
                    @for (contactProperty of filteredHubspotProperties.contact; track 'contact' + contactProperty.name) {
                      @if (contactProperty.fieldType == field.fieldType) {
                        <mat-option [value]="contactProperty.name">{{contactProperty.name}} ({{contactProperty.label}})</mat-option>
                      }
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          }
        }
      </div>
      <h2 class="font-bold text-lg mb-4 mt-6">{{ 'contact_fields_to_vivenu' | translate }}</h2>
      <div class="grid grid-cols-1 gap-6 [&>*:nth-child(odd)]:bg-gray-50 [&>*:nth-child(odd)]:p-4 [&>*:nth-child(even)]:p-4">
        @for (field of vivenuFields; track field.id) {
          @if (field.toExternal && field.objectType == 'contact') {
            <div class="grid grid-cols-3 gap-x-4">
              <div>
                <mat-slide-toggle
                  [disabled]="field.required"
                  [(ngModel)]="field.activeCreate" [ngModelOptions]="{standalone: true}">
                  {{ 'create_on_creation' | translate }}
                </mat-slide-toggle>
                <mat-slide-toggle
                  [disabled]="field.required"
                  [(ngModel)]="field.activeUpdate" [ngModelOptions]="{standalone: true}">
                  {{ 'overwrite_on_update' | translate }}
                </mat-slide-toggle>
              </div>
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'hubspot_target_field' | translate }}</mat-label>
                  <input type="text"
                         placeholder="{{ 'hubspot_target_field' | translate }}"
                         matInput
                         [disabled]="!field.editable"
                         [(ngModel)]="field.value"
                         [ngModelOptions]="{standalone: true}"
                         (keyup)="filterEntries($event, 'contact', field.fieldType)"
                         [matAutocomplete]="auto">
                  <mat-autocomplete autoActiveFirstOption requireSelection #auto="matAutocomplete">
                    @for (contactProperty of filteredHubspotProperties.contact; track 'contact' + contactProperty.name) {
                      @if (contactProperty.fieldType == field.fieldType) {
                        <mat-option [value]="contactProperty.name">{{contactProperty.name}} ({{contactProperty.label}})</mat-option>
                      }
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div>
                {{field.label | translate}} ({{field.fieldType}})
              </div>
            </div>
          }
        }
      </div>
      <h2 class="font-bold text-lg mt-6 mb-4">{{ 'deal_order_fields' | translate }}</h2>
      <div class="grid grid-cols-1 gap-6 [&>*:nth-child(odd)]:bg-gray-50 [&>*:nth-child(odd)]:p-4 [&>*:nth-child(even)]:p-4">
        @for (field of vivenuFields; track field.id) {
          @if (field.objectType == 'deal') {
            <div class="grid grid-cols-3 gap-x-4">
              <div>
                <mat-slide-toggle
                  [disabled]="field.required"
                  [(ngModel)]="field.activeCreate" [ngModelOptions]="{standalone: true}">
                  {{ 'create_on_creation' | translate }}
                </mat-slide-toggle>
                <mat-slide-toggle
                  [disabled]="field.required"
                  [(ngModel)]="field.activeUpdate" [ngModelOptions]="{standalone: true}">
                  {{ 'overwrite_on_update' | translate }}
                </mat-slide-toggle>
              </div>
              <div>
                {{field.label | translate}} ({{field.fieldType}})
              </div>
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'hubspot_target_field' | translate }}</mat-label>
                  <input type="text"
                         placeholder="{{ 'hubspot_target_field' | translate }}"
                         matInput
                         [disabled]="!field.editable"
                         [(ngModel)]="field.value"
                         [ngModelOptions]="{standalone: true}"
                         (keyup)="filterEntries($event, 'deal', field.fieldType)"
                         [matAutocomplete]="auto">
                  <mat-autocomplete autoActiveFirstOption requireSelection #auto="matAutocomplete">
                    @for (dealProperty of filteredHubspotProperties.deal; track 'deal' + dealProperty.name) {
                      @if (dealProperty.fieldType == field.fieldType) {
                        <mat-option [value]="dealProperty.name">{{dealProperty.name}} ({{dealProperty.label}})</mat-option>
                      }
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          } @else if (field.objectType == 'order') {
            <div class="grid grid-cols-3 gap-x-4">
              <div>
                <mat-slide-toggle
                  [disabled]="field.required"
                  [(ngModel)]="field.activeCreate" [ngModelOptions]="{standalone: true}">
                  {{ 'create_on_creation' | translate }}
                </mat-slide-toggle>
                <mat-slide-toggle
                  [disabled]="field.required"
                  [(ngModel)]="field.activeUpdate" [ngModelOptions]="{standalone: true}">
                  {{ 'overwrite_on_update' | translate }}
                </mat-slide-toggle>
              </div>
              <div>
                {{field.label | translate}} ({{field.fieldType}})
              </div>
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'hubspot_target_field' | translate }}</mat-label>
                  <input type="text"
                         placeholder="{{ 'hubspot_target_field' | translate }}"
                         matInput
                         [disabled]="!field.editable"
                         [(ngModel)]="field.value"
                         [ngModelOptions]="{standalone: true}"
                         (keyup)="filterEntries($event, 'order', field.fieldType)"
                         [matAutocomplete]="auto">
                  <mat-autocomplete autoActiveFirstOption requireSelection #auto="matAutocomplete">
                    @for (orderProperty of filteredHubspotProperties.order; track 'order' + orderProperty.name) {
                      @if (orderProperty.fieldType == field.fieldType) {
                        <mat-option [value]="orderProperty.name">{{orderProperty.name}} ({{orderProperty.label}})</mat-option>
                      }
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          }
        }
      </div>
      <h2 class="font-bold text-lg mt-6 mb-4">{{ 'ticket_fields' | translate }}</h2>
      <div class="grid grid-cols-1 gap-6 [&>*:nth-child(odd)]:bg-gray-50 [&>*:nth-child(odd)]:p-4 [&>*:nth-child(even)]:p-4">
        @for (field of vivenuFields; track field.id) {
          @if (field.objectType == 'vivenu_ticket') {
            <div class="grid grid-cols-3 gap-x-4">
              <div>
                <mat-slide-toggle
                  [disabled]="field.required"
                  [(ngModel)]="field.activeCreate" [ngModelOptions]="{standalone: true}">
                  {{ 'create_on_creation' | translate }}
                </mat-slide-toggle>
                <mat-slide-toggle
                  [disabled]="field.required"
                  [(ngModel)]="field.activeUpdate" [ngModelOptions]="{standalone: true}">
                  {{ 'overwrite_on_update' | translate }}
                </mat-slide-toggle>
              </div>
              <div>
                {{field.label | translate}} ({{field.fieldType}})
              </div>
              <div>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'hubspot_target_field' | translate }}</mat-label>
                  <input type="text"
                         placeholder="{{ 'hubspot_target_field' | translate }}"
                         matInput
                         [disabled]="!field.editable"
                         [(ngModel)]="field.value"
                         [ngModelOptions]="{standalone: true}"
                         (keyup)="filterEntries($event, 'vivenu_ticket', field.fieldType)"
                         [matAutocomplete]="auto">
                  <mat-autocomplete autoActiveFirstOption requireSelection #auto="matAutocomplete">
                    @for (ticketProperty of filteredHubspotProperties[vivenu.vivenuTicketsCustomObjectId]; track 'ticket' + ticketProperty.name) {
                      @if (ticketProperty.fieldType == field.fieldType) {
                        <mat-option [value]="ticketProperty.name">{{ticketProperty.name}} ({{ticketProperty.label}})</mat-option>
                      }
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          }
        }
      </div>
      <div class="flex flex-row gap-4">
        <div>
          <button mat-raised-button color="warn" type="button" (click)="createCustomFields()">{{ 'create_vivenu_fields' | translate }}</button>
        </div>
        <div>
          <button mat-raised-button type="button" (click)="saveFields()">{{ 'save_field_mapping' | translate }}</button>
        </div>
      </div>
    }
  </div>
  @if (vivenu) {
  <div>
    <h2 class="text-5xl m-10">
      <strong>vivenu</strong> {{ 'migration' | translate }}
    </h2>
  </div>
  <div class="bg-white p-10 grow mb-16">
    <div class="grid grid-cols-1 gap-6 [&>*:nth-child(odd)]:bg-gray-50 [&>*:nth-child(odd)]:p-4 [&>*:nth-child(even)]:p-4">
      <div class="grid grid-cols-2 gap-x-4">
        <div>
          <mat-slide-toggle
            (change)="updateSingleAttribute('anonymizeMigrationData', $event.checked)"
            labelPosition="after"
            formControlName="anonymizeMigrationData">{{ 'anonymize_migrated_data' | translate }}</mat-slide-toggle>
        </div>
        <div>
          {{ 'anonymize_migrated_data_description' | translate }}
        </div>
      </div>
      <div class="grid grid-cols-2 gap-x-4">
        <div>
          <mat-slide-toggle
            (change)="updateSingleAttribute('migrationDryRun', $event.checked)"
            labelPosition="after"
            formControlName="migrationDryRun">{{ 'dry_run' | translate }}</mat-slide-toggle>
        </div>
        <div>
          {{ 'dry_run_description' | translate }}
        </div>
      </div>
      <div class="grid grid-cols-2 gap-x-4">
        <div>
          <mat-form-field class="w-full">
            <mat-label>{{ 'time_range' | translate }}</mat-label>
            <mat-select
              (valueChange)="updateSingleAttribute('migrationTimerange', $event)"
              formControlName="migrationTimerange">
              @for (range of migrationTimerange; track range) {
                <mat-option [value]="range.value">{{range.viewValue | translate}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          {{ 'time_range_description' | translate }}
        </div>
      </div>
      <div class="grid grid-cols-2 gap-x-4">
        <div>
          <button mat-raised-button type="button"
                  [disabled]="latestContactMigration.status == 'running' || latestTransactionMigration.status == 'running'"
                  (click)="migrate('contacts')">{{ 'migrate_contacts' | translate }}</button>
        </div>
        @if (latestContactMigration.status == 'running') {
          <div>
            <div class="font-bold">{{ 'migration_running' | translate }}</div>
            <div class="text-sm pt-2">{{ 'started' | translate }}: {{latestContactMigration.migrationDate | date:'medium'}}</div>
            <div class="py-1">
              <mat-progress-bar mode="determinate" [value]="latestContactMigration.skip / latestContactMigration.total * 100"></mat-progress-bar>
            </div>
            <div class="text-sm">{{latestContactMigration.migrated}}/{{latestContactMigration.total}} {{ 'contacts_migrated' | translate }}</div>
          </div>
        } @else if (latestContactMigration.status == 'failed') {
          <div>
            <div class="text-red-500 font-bold">{{ 'migration_failed' | translate }}</div>
          </div>
        } @else if (latestContactMigration.status == 'failed_partial') {
          <div>
            <div class="text-red-500 font-bold">{{ 'migration_failed_partially' | translate }}</div>
          </div>
        } @else {
          <div>
            {{ 'migrate_contacts_description' | translate }}
            @if (latestContactMigration.status == 'completed') {
              <br />
              <br />
              <span class="text-green font-bold">{{ 'last_contacts_migration' | translate }}: {{latestContactMigration.migrationDate | date:'medium'}}</span>
              <div class="text-sm">{{latestContactMigration.total}} {{ 'contacts_migrated' | translate }}</div>
            }
          </div>
        }
      </div>
      <div class="grid grid-cols-2 gap-x-4">
        <div>
          <button mat-raised-button type="button"
                  [disabled]="latestContactMigration.status == 'running' || latestTransactionMigration.status == 'running'"
                  (click)="migrate('contacts_orders')">{{ 'migrate_purchases_with_contacts' | translate }}</button>
        </div>
        @if (latestTransactionContactMigration.status == 'running') {
          <div>
            <div class="font-bold">{{ 'migration_running' | translate }}</div>
            <div class="text-sm pt-2">{{ 'started' | translate }}: {{latestTransactionContactMigration.migrationDate | date:'medium'}}</div>
            <div class="py-1">
              <mat-progress-bar mode="determinate" [value]="latestTransactionContactMigration.skip / latestTransactionContactMigration.Total * 100"></mat-progress-bar>
            </div>
            <div class="text-sm">{{latestTransactionContactMigration.migrated}}/{{latestTransactionContactMigration.total}} {{ 'purchases_migrated' | translate }}</div>
          </div>
        } @else if (latestTransactionContactMigration.status == 'failed') {
          <div>
            <div class="text-red-500 font-bold">{{ 'migration_failed' | translate }}</div>
          </div>
        } @else if (latestTransactionContactMigration.status == 'failed_partial') {
          <div>
            <div class="text-red-500 font-bold">{{ 'migration_failed_partially' | translate }}</div>
          </div>
        } @else {
          <div>
            {{ 'migrate_purchases_with_contacts_description' | translate }}
            @if (latestTransactionContactMigration.status == 'completed') {
              <br />
              <br />
              <span class="text-green font-bold">{{ 'last_purchases_migration' | translate }}: {{latestTransactionContactMigration.migrationDate | date:'medium'}}</span>
              <div class="text-sm">{{latestTransactionContactMigration.total}} {{ 'purchases_migrated' | translate }}</div>
            }
          </div>
        }
      </div>
      <div class="grid grid-cols-2 gap-x-4">
        <div>
          <button mat-raised-button type="button"
                  [disabled]="latestContactMigration.status == 'running' || latestTransactionMigration.status == 'running'"
                  (click)="migrate('orders')">{{ 'migrate_purchases_without_contacts' | translate }}</button>
        </div>
        @if (latestTransactionMigration.status == 'running') {
          <div>
            <div class="font-bold">{{ 'migration_running' | translate }}</div>
            <div class="text-sm pt-2">{{ 'started' | translate }}: {{latestTransactionMigration.migrationDate | date:'medium'}}</div>
            <div class="py-1">
              <mat-progress-bar mode="determinate" [value]="latestTransactionMigration.skip / latestTransactionMigration.Total * 100"></mat-progress-bar>
            </div>
            <div class="text-sm">{{latestTransactionMigration.migrated}}/{{latestTransactionMigration.total}} {{ 'purchases_migrated' | translate }}</div>
          </div>
        } @else if (latestTransactionMigration.status == 'failed') {
          <div>
            <div class="text-red-500 font-bold">{{ 'migration_failed' | translate }}</div>
          </div>
        } @else if (latestTransactionMigration.status == 'failed_partial') {
          <div>
            <div class="text-red-500 font-bold">{{ 'migration_failed_partially' | translate }}</div>
          </div>
        } @else {
          <div>
            {{ 'migrate_purchases_without_contacts_description' | translate }}
            @if (latestTransactionMigration.status == 'completed') {
              <br />
              <br />
              <span class="text-green font-bold">{{ 'last_purchases_migration' | translate }}: {{latestTransactionMigration.migrationDate | date:'medium'}}</span>
              <div class="text-sm">{{latestTransactionMigration.total}} {{ 'purchases_migrated' | translate }}</div>
            }
          </div>
        }
      </div>
    </div>
  </div>
  }
  }
</div>
</form>
